import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-modal',
  imports: [
    CommonModule,
    DialogModule
  ],
  templateUrl: './modal.component.html'
})
export class ModalComponent {
  @Input() header = '';
  @Input() visible = false;
  @Input() focusOnShow = true;
  @Output() visibleChange = new EventEmitter<boolean>();

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

}
